'use client'

import { usePathname, useRouter } from 'next/navigation'
import { Link } from '@astryxdesign/core/Link'
import { Button } from '@astryxdesign/core/Button'
import { useSession } from '@/app/components/SessionProvider'

// ponytail: astryx Button for header CTAs even though they navigate; Button
// has no `as`/href and a Link balks at button-styling. Swap when (if) astryx
// ships a button-styled link primitive.
function Cta({ href, label, variant }) {
  const router = useRouter()
  return (
    <Button label={label} variant={variant} size="sm" onClick={() => router.push(href)} />
  )
}

export default function NavActions({
  isSignedIn,
  hasSeekerProfile,
  hasReferrerProfile,
}) {
  const pathname = usePathname() || ''
  const isSeekerSignupPage = pathname.startsWith('/seekers/signup')
  const isReferrerSignupPage = pathname.startsWith('/referrers/signup')
  const session = useSession()
  const hasProps = isSignedIn !== undefined
    || hasSeekerProfile !== undefined
    || hasReferrerProfile !== undefined

  if (!hasProps && session === null) {
    return (
      <div className="nav-actions nav-actions-skeleton" aria-hidden="true">
        <span className="nav-actions-skeleton-link" />
        <span className="nav-actions-skeleton-link" />
        <span className="nav-actions-skeleton-btn" />
      </div>
    )
  }

  const signedIn = hasProps ? isSignedIn : session.isSignedIn
  const seekerProfile = hasProps ? hasSeekerProfile : session.hasSeekerProfile
  const referrerProfile = hasProps ? hasReferrerProfile : session.hasReferrerProfile

  if (signedIn) {
    return (
      <div className="nav-actions">
        <Link href="/negotiation-simulator">Practice negotiation</Link>
        <Link href="/resources">Resources</Link>
        <Link href="/new-features">New Features</Link>
        {seekerProfile ? (
          <Cta
            href="/seekers/dashboard"
            label="Seeker dashboard"
            variant={referrerProfile ? 'secondary' : 'primary'}
          />
        ) : null}
        {referrerProfile ? (
          <Cta href="/referrers/dashboard" label="Referral dashboard" variant="primary" />
        ) : null}
        {!seekerProfile && !referrerProfile ? (
          <Cta href="/seekers/dashboard" label="Open dashboard" variant="primary" />
        ) : null}
        <form action="/logout" method="post" className="nav-sign-out-form">
          <Button label="Sign out" type="submit" variant="secondary" size="sm" />
        </form>
      </div>
    )
  }

  return (
    <div className="nav-actions">
      <Link href="/negotiation-simulator">Practice negotiation</Link>
      <Link href="/resources">Resources</Link>
      <Link href="/login">Log In</Link>
      {isSeekerSignupPage ? null : (
        <Cta href="/seekers/signup" label="Looking for a role" variant="secondary" />
      )}
      {isReferrerSignupPage ? null : (
        <Cta href="/referrers/signup" label="Sign up to refer" variant="primary" />
      )}
    </div>
  )
}